<div id="attachmentsModal" class="modal fade" tabindex="-1" role="dialog"
     data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg center-modal" role="document">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header bg-primary clearfix">
        <div>
          <button class="btn btn-link pull-right" type="button" data-dismiss="modal">x</button>
        </div>
        <div class="row col-md-11 col-sm-10 col-xs-10">
          <h4 class="modal-title">
            {{'Attachments' | translate}}
            <span class="label label-default" *ngIf="count > 0">{{count}}/{{maxAllowed}}</span>
          </h4>
        </div>
      </div>

      <div class="modal-body">
        <!-- Upload area (owner mode only) -->
        <div *ngIf="editable" class="attachment-upload-area">
          <div id="attachment-uppy-dashboard"></div>
        </div>

        <!-- Loading spinner -->
        <div *ngIf="loading" class="text-center" style="padding: 20px;">
          <i class="icon-spinner2 spinner"></i>
        </div>

        <!-- Empty state -->
        <div *ngIf="!loading && count === 0" class="text-center text-muted" style="padding: 20px;">
          <i class="icon-file-empty2" style="font-size: 48px;"></i>
          <p>{{'No attachments' | translate}}</p>
        </div>

        <!-- Sort A→Z button (owner mode, 2+ attachments) -->
        <div *ngIf="editable && !loading && count > 1" class="text-right" style="margin-top: 10px;">
          <button class="btn btn-xs btn-default" (click)="sortAlphabetically()"
                  title="{{'Sort A→Z' | translate}}">
            <i class="icon-sort-alpha-asc"></i> {{'Sort A→Z' | translate}}
          </button>
        </div>

        <!-- Attachment list -->
        <ul class="list-group" *ngIf="!loading && count > 0" style="margin-top: 10px;"
            cdkDropList [cdkDropListData]="attachments"
            [cdkDropListDisabled]="!editable"
            (cdkDropListDropped)="onDrop($event)">
          <li class="list-group-item" *ngFor="let attachment of attachments" cdkDrag
              [cdkDragDisabled]="!editable || attachment._editing">
            <div class="row attachment-row">
              <!-- Drag handle (owner only) -->
              <div *ngIf="editable" class="col-md-1 col-sm-1 col-xs-1 text-center drag-handle"
                   cdkDragHandle title="{{'Drag to reorder' | translate}}">
                <i class="icon-menu7"></i>
              </div>
              <!-- File icon -->
              <div class="col-md-1 col-sm-1 col-xs-1 text-center">
                <i [class]="getFileIcon(attachment.mimeType)" style="font-size: 22px;"></i>
              </div>
              <!-- Name (inline editable for owner) -->
              <div [ngClass]="editable ? 'col-md-4 col-sm-4 col-xs-4' : 'col-md-5 col-sm-5 col-xs-5'">
                <span *ngIf="!attachment._editing"
                      class="attachment-name"
                      [title]="attachment.displayName || attachment.name">
                  {{attachment.displayName || attachment.name}}
                </span>
                <input *ngIf="attachment._editing" type="text" class="form-control input-sm"
                       [(ngModel)]="attachment._editName"
                       (keydown.enter)="saveRename(attachment)"
                       (keydown.escape)="cancelRename(attachment)">
              </div>
              <!-- Size -->
              <div class="col-md-2 col-sm-2 col-xs-2 text-muted">
                {{formatFileSize(attachment.size)}}
              </div>
              <!-- Actions -->
              <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <button *ngIf="editable && !attachment._editing" class="btn btn-xs btn-link"
                        (click)="startRename(attachment)" title="{{'Rename' | translate}}">
                  <i class="icon-pencil"></i>
                </button>
                <button *ngIf="attachment._editing" class="btn btn-xs btn-success"
                        (click)="saveRename(attachment)">
                  <i class="icon-checkmark"></i>
                </button>
                <button *ngIf="attachment._editing" class="btn btn-xs btn-default"
                        (click)="cancelRename(attachment)">
                  <i class="icon-cross"></i>
                </button>
                <button class="btn btn-xs btn-link" (click)="downloadAttachment(attachment)"
                        title="{{'Download' | translate}}">
                  <i class="icon-download"></i>
                </button>
                <button *ngIf="editable" class="btn btn-xs btn-link text-danger"
                        (click)="confirmDelete(attachment)" title="{{'Delete' | translate}}">
                  <i class="icon-trash"></i>
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button *ngIf="count > 1" class="btn btn-default pull-left" (click)="downloadAllAsZip()">
          <i class="icon-download"></i> {{'Download All as ZIP' | translate}}
        </button>
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>
